import { useEffect, useRef } from 'react';
import { useAnalytics } from '@/services/analytics';

import { type Asset } from '@/services/db/asset/entity';

import { type FolderPath } from '../types';

export function useFolderViewedTracking({
  parentFolderId,
  isLoading,
  error,
  searchIsActive,
  filteredAssets,
  folderPaths,
}: {
  parentFolderId: string | null;
  isLoading: boolean;
  error: boolean;
  searchIsActive: boolean;
  filteredAssets: Asset[];
  folderPaths: FolderPath[];
}) {
  const { track } = useAnalytics();
  const lastTrackedFolderIdRef = useRef<string | null | undefined>(undefined);

  useEffect(
    function trackFolderViewed() {
      if (isLoading || error) return;
      if (searchIsActive) return;
      if (lastTrackedFolderIdRef.current === parentFolderId) return;

      let folderCount = 0;
      let assetCount = 0;
      for (const asset of filteredAssets) {
        if (asset.is_dir) {
          folderCount++;
        } else {
          assetCount++;
        }
      }

      const currentFolder = folderPaths.at(-1);
      track('assetLibrary', 'folderViewed', {
        folder_name: currentFolder?.name ?? '',
        folder_id: parentFolderId,
        folder_count: folderCount,
        asset_count: assetCount,
      });

      lastTrackedFolderIdRef.current = parentFolderId;
    },
    [parentFolderId, isLoading, error, searchIsActive, filteredAssets, folderPaths, track],
  );
}
